import sortBy from 'lodash/sortBy';
import { User } from 'api/models';
import {
  CsatRating,
  CsatRating$Api,
  ProjectManagerRating,
  ProjectManagerRating$Api,
  TemplateRating,
  TemplateRating$Api,
  Template,
} from 'api/reports/csat';
import { ProjectInUserProfile } from 'api/user';

export const RATING_COLOR_HASH = {
  5: '#24a148',
  4: '#6fdc8c',
  3: '#ffbf00',
  2: '#fa4d56',
  1: '#a2191f',
};

export const transformCsatData = (
  data: CsatRating$Api[],
  projects: ProjectInUserProfile[],
  users: User[],
  templates: Template[],
): CsatRating[] => {
  return sortBy(data, 'actionAt')
    .reverse()
    .map((d) => {
      const {
        projectId,
        actionBy,
        taskTemplateId,
        projectTemplateId,
        ...rest
      } = d;
      const project = projects.find((p) => p.projectId === projectId)!;
      const user = users.find((u) => u.userId === actionBy)!;
      const taskTemplate = templates.find(
        (t) => t.templateId === taskTemplateId,
      );
      const projectTemplate = templates.find(
        (t) => t.templateId === projectTemplateId,
      );

      return (
        project &&
        user && {
          ...rest,
          project,
          actionBy: user,
          taskTemplate,
          projectTemplate,
        }
      );
    })
    .filter(Boolean);
};

export const transformProjectManagersRatings = (
  data: ProjectManagerRating$Api[],
  users: User[],
): ProjectManagerRating[] => {
  return data
    .map((d) => {
      const projectManager = users.find((u) => u.userId === d.projectManager)!;

      return (
        projectManager && {
          ...d,
          projectManager,
        }
      );
    })
    .filter(Boolean);
};

export const transformTemplateRatings = (
  data: TemplateRating$Api[],
  templates: Template[],
): TemplateRating[] => {
  return data
    .map((d) => {
      const projectTemplate = templates.find(
        (u) => u.templateId === d.sourceId,
      )!;

      return (
        projectTemplate && {
          ...d,
          projectTemplate,
        }
      );
    })
    .filter(Boolean);
};
